import React, { useState } from 'react';
import './HomeBanner.css';
import {
  FaPhoneAlt,
  FaSearch,
  FaWhatsapp,
  FaEnvelope,
  FaMicrophone,
  FaCrosshairs
} from 'react-icons/fa';
// import SpotlightSection from './SpotlightSection';

import PropertySlider from './components/PropertySlider';
import { useNavigate } from 'react-router-dom';
import Services from './Services';
// import { isPrimaryPointer } from 'framer-motion';
// import OurBrand from './OurBrand';
import DevelopersPage from './Developers/Developer';

const HomeBanner = () => {
  const [showIntro, setShowIntro] = useState(() => {
    return sessionStorage.getItem('hasSeenIntro') !== 'true';
  });
  const [videoEnded, setVideoEnded] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedConfiguration, setSelectedConfiguration] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [listening, setListening] = useState(false);

  const categories = ['Residential', 'Commercial', 'Plots', 'Industrial'];

  const configurations = [
    '1 BHK', '2 BHK', '3 BHK', '4 BHK', '5 BHK', '6 BHK', '7 BHK',
    'Penthouse', 'Independent Villa/House', 'Shops', 'Office Space',
    'NA Plots', 'Agriculture Land', 'Warehouse', 'Cold Storage'
  ];

  const cities = ['Mumbai', 'Pune', 'Goa', 'Dubai'];
  const navigate = useNavigate();

  const handleVideoEnd = () => {
    setVideoEnded(true);
    setTimeout(() => {
      sessionStorage.setItem('hasSeenIntro', 'true');
      setShowIntro(false);
    }, 500); // Small delay for smooth transition
  };

  const handleSkipIntro = () => {
    sessionStorage.setItem('hasSeenIntro', 'true');
    setShowIntro(false);
  };

  const handleSearch = async () => {
    setErrorMsg('');
    setSearchResults([]);
    try {
      const params = new URLSearchParams();
      if (searchQuery) params.append('query', searchQuery);
      if (selectedCategory) params.append('category', selectedCategory.toLowerCase());
      if (selectedConfiguration) params.append('configuration', selectedConfiguration.toLowerCase());
      if (selectedCity) params.append('city', selectedCity.toLowerCase());

      const url = `https://pp-backend-1-sa8p.onrender.com/properties?${params.toString()}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch properties');
      const data = await response.json();

      if (data.length === 0) {
        setErrorMsg('No results found. Try different search terms.');
      }

      setSearchResults(data);

      // Clear the search bar and filters
      setSearchQuery('');
      setSelectedCategory('');
      setSelectedConfiguration('');
      setSelectedCity('');

    } catch (error) {
      console.error(error);
      setErrorMsg('Failed to load search results. Please try again.');
    }
  };

  const handleNearMe = () => {
    setErrorMsg('');
    if (!navigator.geolocation) {
      setErrorMsg('Geolocation is not supported by your browser.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setSearchQuery(`${latitude},${longitude}`);
        setSelectedCity('');
        setSelectedCategory('');
        setSelectedConfiguration('');
        (async () => {
          try {
            const params = new URLSearchParams();
            params.append('nearLat', latitude);
            params.append('nearLng', longitude);
            const url = `https://pp-backend-1-sa8p.onrender.com/properties?${params.toString()}`;
            const response = await fetch(url);
            if (!response.ok) throw new Error('Failed to fetch properties');
            const data = await response.json();

            if (data.length === 0) {
              setErrorMsg('No nearby properties found.');
            }
            setSearchResults(data);
          } catch (error) {
            console.error(error);
            setErrorMsg('Failed to load nearby properties.');
          }
        })();
      },
      () => {
        setErrorMsg('Unable to retrieve your location.');
      }
    );
  };

  const handleVoiceInput = () => {
    if (!('webkitSpeechRecognition' in window)) {
      setErrorMsg('Speech recognition is not supported in this browser.');
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => setListening(true);
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setSearchQuery(transcript);
      setListening(false);
    };
    recognition.onerror = () => {
      setErrorMsg('Speech recognition error. Please try again.');
      setListening(false);
    };
    recognition.onend = () => setListening(false);
    recognition.start();
  };

  return (
    <div>
      {showIntro ? (
        <div className={`intro-screen ${videoEnded ? 'fade-out' : 'fade-in'}`}>
          
      <div className="video-container">
  <video 
    autoPlay 
    muted 
    playsInline 
    onEnded={handleVideoEnd}
    className="intro-video"
  >
    <source
      src="https://res.cloudinary.com/dygjp3qhl/video/upload/v1751008028/intro-small_vevszo.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
</div>


       
          <button className="skip-intro-btn" onClick={handleSkipIntro}>
            Skip Intro
          </button>
        </div>
      ) : (
        <>
          {/* Hero Section */}
           <div className="home-hero-section" style={{ background: "url('/bghome.png') no-repeat center center / cover" }}>
            <div className="hero-overlay">
              <div className="search-bar-container">
                <div className="search-bar">
                  <div className="search-input-container">
                    <FaSearch className="search-icon" />
                    <input
                      type="text"
                      placeholder="Enter an address, city, state, area or zip code"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
              </div>

                  <div className="search-actions">
                    <button className="near-me-btn" onClick={handleNearMe} title="Search properties near your location">
                      <FaCrosshairs /> <span className="action-text">Near Me</span>
                    </button>

                    <button className="voice-btn" onClick={handleVoiceInput} title="Search by voice" style={{ backgroundColor: listening ? '#4caf50' : undefined }}>
                      <FaMicrophone />
                    </button>
                  </div>

                  <div className="search-filters">
                    <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                      <option value="">Categories</option>
                      {categories.map((cat) => <option key={cat} value={cat}>{cat}</option>)}
                    </select>

                    <select value={selectedConfiguration} onChange={(e) => setSelectedConfiguration(e.target.value)}>
                      <option value="">Configuration</option>
                      {configurations.map((cfg) => <option key={cfg} value={cfg}>{cfg}</option>)}
                    </select>

                    <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)}>
                      <option value="">Select City</option>
                      {cities.map((city) => <option key={city} value={city}>{city}</option>)}
                    </select>
                  </div>

                  <button className="search-button-green" onClick={handleSearch}>
                    <span className="search-button-text">Search Listing</span>
                  </button>
                </div>
              </div>

              <div className="hero-tagline-container">
                <div className="hero-tagline"><h1>A Compass To Your Home</h1></div>
              </div>

              <div className="city-links">
                {cities.map((city) => (
                  <button key={city} className="city-button" onClick={() => setSelectedCity(city)}>
                    {city}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Search Results */}
          <div className="search-results">
            {errorMsg && <p className="error-message">{errorMsg}</p>}
            {searchResults.length > 0 && (
              <div className="results-container">
                {searchResults.map((property) => (
                  <div key={property.id || property._id} className="property-card">
                    <img
                      src={property.propertyImages?.[0]?.url || "https://via.placeholder.com/400x250"}
                      alt={property.title}
                    />
                    <h3>{property.title || property.name}</h3>
                    <p className="property-address">{property.address || property.location}</p>
                    <p><strong>Price:</strong> {property.price ? `₹${Number(property.price).toLocaleString()}` : 'N/A'}</p>
                    <p><strong>Configuration:</strong> {property.configuration || 'N/A'}</p>
                    <p><strong>Category:</strong> {property.category || 'N/A'}</p>
                    <button
                      onClick={() => navigate(`/property/${property.slug}`)}
                      className="view-details-btn"
                    >
                      View Details
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Connect Section */}
          <div className="connect-section">
            <h3>Let's Sort It Out Together!</h3>
            <p className="connect-subtext">
              Our experts at <span className="brand">Property Plateau</span> are here to assist you every step of the way.
            </p>
            <div className="connect-options">
              <a href="tel:+919156091640" className="connect-button call"><FaPhoneAlt /> <span>Call Now</span></a>
              <a href="https://wa.me/919156091640" target="_blank" rel="noreferrer" className="connect-button whatsapp"><FaWhatsapp /> <span>Chat on WhatsApp</span></a>
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=customerservice@propertyplateau.com" target="_blank" rel="noopener noreferrer" className="connect-button email">
                <FaEnvelope /> <span>Email Us</span>
              </a>
            </div>
          </div>

          {/* Featured Properties */}
          <div className="featured-properties-section">
            <h2>Featured Luxury Property</h2>
            <PropertySlider />
          </div>

          <Services/>
          {/* <OurBrand/> */}
         
          <DevelopersPage/>
      
        </>
      )}
    </div>
  );
};

export default HomeBanner;